import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgLayoutImmersive = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22.5 2.25H1.5V9.75H22.5V2.25Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.5 21.75H22.5M1.5 15.75H22.5",
		stroke: "currentColor",
		strokeOpacity: .5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgKgLayoutImmersive;
